<template>
  <div id="app">
    <herder></herder>
    <div class="closs" v-if="show == 1">
      <p></p>
      <p></p>
      <p>系统已关闭。</p>
      <img src="./assets/images/tips.png" alt="" />
    </div>
    <router-view v-if="show == 2" />
  </div>
</template>
<script>
import herder from "../src/components/herder.vue";
import { getconfig } from "@/api/news";
export default {
  components: {
    herder,
  },
  data() {
    return {
      show: 1, //0-开启、1-关闭、2-正常
      time: "", //当前时间
      isPC: 0, //0-pc、 1-手机
    };
  },
  computed: {
    shows() {
      const str = Number(20240701080000);
      const end = Number(20240703080000);
      const now = Number(this.getCurrentTime());
      console.log(now);
      if (str <= now && now <= end) {
        return 1;
      } else {
        return 1;
      }
    },
  },
  watch: {
    time(val) {
      // console.log(val);
      const str = Number(20240701080000);
      const end = Number(20240703080000);
      const now = Number(val);
      // console.log(now);
      if (str <= now && now <= end) {
        this.show = 2;
      } else {
        this.show = 1;
      }
    },
  },
  created() {
    // this.getconfig();
    this.getScreen();
    // this.removeScroll();
    this.ceshi();
    this.shipei();
    this.autoFontSize();
    // this.currentTime();
  },
  methods: {
    //定时器调取当前时间
    currentTime() {
      this.dataTimer = setInterval(() => {
        this.time = this.getCurrentTime();
      }, 1000);
    },
    //获取当前时间
    getCurrentTime() {
      //获取当前时间并打印
      let yy = new Date().getFullYear();
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      return yy + "" + mm + "" + dd + "" + hh + "" + mf + "" + ss;
    },
    //获取配置开放信息
    async getconfig() {
      this.$toast.loading();
      const data = await getconfig();
      console.log(data);
      this.$toast.clear();
      if (data.code == 200) {
        if (data.data == 0) {
          this.show = "1";
        }
      } else {
        this.$message.error(data.msg);
      }
    },
    getScreen() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        this.isPC = 1;
        console.log("手机端");
        //修改src/router/index.js，在这里增加自己的要跳转的页面
      } else {
        this.isPC = 0;
        console.log("pc端");
      }
      sessionStorage.setItem("isPC", JSON.stringify(this.isPC));
    },
    ceshi() {
      document.querySelector("html").style.height = `${window.innerHeight}px`; //适配手机端防止底部留白
    },
    autoFontSize() {
      if (
        typeof WeixinJSBridge == "object" &&
        typeof WeixinJSBridge.invoke == "function"
      ) {
        //判断程序运行环境是否是微信浏览器(微信内置的浏览器)
        this.handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.handleFontSize,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", this.handleFontSize);
        }
      }
    },
    handleFontSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke("setFontSizeCallback", {
        fontSize: 0,
      });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on("menu:setfont", () => {
        WeixinJSBridge.invoke("setFontSizeCallback", {
          fontSize: 0,
        });
      });
    },
    shipei() {
      window.onload = function () {
        document.addEventListener("touchstart", function (event) {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        });
        document.addEventListener("gesturestart", function (event) {
          event.preventDefault();
        });
      };
    },
    removeScroll() {
      //溢出隐藏(禁止页面滑动)
      document.body.style.overflow = "hidden";
      // 处理iOS 微信客户端弹窗状态下调起输入法后关闭输入法页面元素错位解决办法
      var ua = window.navigator.userAgent.toLowerCase();
      if (
        /iphone|ipod|ipad/i.test(navigator.appVersion) &&
        /MicroMessenger/i.test(ua)
      ) {
        document.body.addEventListener("focusout", () => {
          console.log("focusout");
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        });
      }
    },
    shipei1() {
      let lastTouchEnd = 0;
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener(
        "touchend",
        function (event) {
          let now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
      // 阻止双指放大
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    },
  },
  mounted() {
    this.ceshi();
    this.shipei();
    this.shipei1();
    this.autoFontSize();
    window.addEventListener("resize", () => {
      // this.changeHtmlFontSizeHandle();
      this.autoFontSize();
    });
  },
};
</script>
<style lang="less" scoped>
.closs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1rem;
  margin-top: 1rem;
  img {
    margin-top: 1rem;
    width: 80%;
    // height: 16rem;
  }
}
</style>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 2rem);
  box-sizing: border-box;
}
html,
body {
  // overflow: hidden;
  width: 100%;
  height: 100%;
}
// * {
//   padding: 0;
//   margin: 0;
//   list-style: none;
//   text-decoration: none;
// }

// body {
//   display: block;
//   /* 触发bfc */
//   overflow: hidden;
// }
</style>
